import { HOST_URL } from 'config';
import AjaxUtil from '../../../common/Js/AjaxHelper/AjaxUtil';
import { ApiEndPoints } from '../../../common/ApiHelper/ApiUrls';
import { APIS } from 'config';

const AlertApiBase = '/Alerts';

export default class alertsApi {
  static updateAlertStatus(alert) {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/SetAlertStatus`);
    let body = alert;
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static updateAllAlertsStatus(alert) {
    let url = HOST_URL + '/WebApp/Alerts/SetAllAlertsStatus';
    let body = alert;
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static countOpenAlerts() {
    let url = `${ApiEndPoints.Alerts.CountOpenAlerts}`;
    return AjaxUtil.sendGet(url);
  }

  static getAlertsCountByEntity() {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/GetAlertsByEntity`);

    return AjaxUtil.sendGet(url);
  }

  static getAlertCountByDate() {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/GetAlertCountByDate`);
    return AjaxUtil.sendGet(url);
  }

  static getSearchAllOverallAlerts(criterias) {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/SearchAlerts`);
    let body = criterias;

    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static getAlertProcessTree(alertId) {
    let url = HOST_URL + '/WebApp/Alerts/GetAlertProcessTreeAsync?alertId=' + alertId;
    return AjaxUtil.sendGet(url);
  }

  static getComments(alertId) {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/GetAllComment?alertId=${alertId}`);

    return AjaxUtil.sendGet(url);
  }

  static addComment(comment) {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/AddComment`);
    let body = comment;
    return AjaxUtil.genericSendPost(url, JSON.stringify(body)); // in the return { resultObj: json }
  }

  static addComments(comments) {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/AddComments`);
    let body = comments;
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static exportToExcel(criterias) {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/ExportToExcel`);
    let body = criterias;
    return AjaxUtil.postDownloadFile(url, JSON.stringify(body));
  }

  static getAlertById(alertId) {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/GetAlertById`);

    let body = { alertId: alertId };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static getModulesWithCategories() {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/GetAlertModulesWithCategories`);
    return AjaxUtil.sendGet(url);
  }

  //only api for Global
  static GetAllSitesGlobal() {
    const url = AjaxUtil.getUrl(`/Users/GetSitesByLoggedInUserSitesPermissions`, APIS.GLOBAL);
    return AjaxUtil.sendGet(url);
  }

  static setTagToAlert(alertId, tagId) {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/SetAlertTag`);
    let body = { alertId: alertId, tagId: tagId };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static removeTagFromAlert(alertId, tagId) {
    const url = AjaxUtil.getUrl(`${AlertApiBase}/RemoveAlertTag`);
    let body = { alertId: alertId, tagId: tagId };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }
}
